<template>
  <div>
    <Navbar activeDirectory="admin" activePage="admin-calendar"></Navbar>
    <div class="container-fluid py-4">
      <div class="row">
        <div class="col-12">
          <!-- Page Header -->
          <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap text-left">
            <div class="d-flex align-items-center">
              <div class="cw-header-icon mr-3">
                <i class="mdi mdi-calendar"></i>
              </div>
              <div class="text-left">
                <h3 class="mb-0 font-weight-bold text-dark">Programmazione Lavori</h3>
                <p class="mb-0 text-muted small">Visualizza e monitora la programmazione dei lavori nel sistema</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-12">
          <div class="cw-card" v-if="viewMode === 'calendar'">
            <vue-cal
              style="height: 700px"
              locale="it"
              :disable-views="['years', 'year']"
              :events="events"
              :time-from="6 * 60"
              :time-to="20 * 60"
              :split-days="activeView === 'day' ? teamsSplits : []"
              sticky-split-labels
              min-split-width="150"
              :on-event-click="onEventClick"
              @cell-dblclick="onCellClick"
              @view-change="onViewChange"
              :editable-events="{ title: false, drag: true, resize: false, create: false, delete: false }"
              @event-drop="onEventDrop"
              class="vuecal--custom-theme"
            >
              <!-- Event renderer for more details -->
              <template v-slot:event="{ event, view }">
                <div class="vuecal__event-title font-weight-bold small text-truncate">
                  <i class="mdi mdi-alert-circle-outline mr-1" v-if="event.class === 'vuecal-event-danger'"></i>
                  <i class="mdi mdi-road-variant mr-1" v-else></i>
                  {{ event.title }}
                </div>
                <div class="vuecal__event-content small text-truncate" v-if="view.id !== 'month'">
                  {{ event.content }}
                </div>
              </template>
            </vue-cal>
          </div>
          
          <!-- <div class="cw-card" v-if="viewMode === 'gantt'">
            <road-gantt 
              :events="events" 
              :teams="teamsSplits" 
              @event-click="onEventClick"
              @event-drop="onEventDrop"
            />
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Navbar, RoadGantt } from "@/components";
import { Navbar } from "@/components";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
// Require vue-cal locale
import 'vue-cal/dist/i18n/it.es.js';
import moment from "moment";
import { nomeIntervento } from "@/utils/intervento";

export default {
  components: {
    Navbar,
    VueCal
    // RoadGantt
  },

  data() {
    return {
      lavori: [],
      loading: true,
      tipologia: localStorage.getItem("tipologia"),
      events: [],
      teamsSplits: [],
      activeView: 'week', // default di vue-cal
      viewMode: 'calendar' // 'calendar' o 'gantt'
    };
  },

  mounted() {
    if (this.tipologia !== "B" && this.tipologia !== "D") {
      this.$router.push({ name: "home" });
    } else {
      this.fetchAdminLavori();
    }
  },

  methods: {
    fetchAdminLavori() {
      this.loading = true;
      this.axios
        .get("dockyard/assigned_by_me")
        .then((response) => {
          this.lavori = response.data;
          this.mapEvents();
          this.loading = false;
        })
        .catch((error) => {
          console.error("Errore nel recupero lavori admin:", error);
          this.loading = false;
          this.$swal.fire({
            icon: "error",
            title: "Errore",
            text: "Impossibile recuperare i lavori per il calendario.",
          });
        });
    },

    mapEvents() {
      const newEvents = [];
      const teamsMap = new Map();
      
      for (const lavoro of this.lavori) {
        if (!teamsMap.has(lavoro.team.id)) {
          teamsMap.set(lavoro.team.id, { id: lavoro.team.id, class: 'vuecal-split-team', label: lavoro.team.nome });
        }

        let baseDate = lavoro.avvio ? moment(lavoro.avvio) : moment();
        let startDateStr = lavoro.data_programmazione ? lavoro.data_programmazione : baseDate.format('YYYY-MM-DD');
        let startTimeStr = lavoro.ora_programmazione ? lavoro.ora_programmazione : "08:00";
        
        let startDate = moment(`${startDateStr} ${startTimeStr}`, 'YYYY-MM-DD HH:mm');
        let endDate = moment(startDate).add(2, 'hours'); // Default duration 2 hours
        
        let cssClass = 'vuecal-event-default';
        if (lavoro.intervento === 'emergenza_carreggiata') {
          cssClass = 'vuecal-event-danger';
        } else if (lavoro.intervento === 'sfalcio') {
          cssClass = 'vuecal-event-primary';
        } else if (lavoro.intervento === 'buca') {
          cssClass = 'vuecal-event-success';
        } else if (lavoro.intervento === 'pulizia' || lavoro.intervento === 'rifiuto') {
          cssClass = 'vuecal-event-warning';
        }

        newEvents.push({
          start: startDate.format('YYYY-MM-DD HH:mm'),
          end: endDate.format('YYYY-MM-DD HH:mm'),
          title: `${nomeIntervento(lavoro.intervento).toUpperCase()}`,
          content: `${lavoro.strada} - ${lavoro.team.nome}`,
          class: cssClass,
          split: lavoro.team.id,
          id: lavoro.uuid
        });
      }
      
      this.teamsSplits = Array.from(teamsMap.values());
      this.events = newEvents;
    },

    onViewChange(e) {
      this.activeView = e.view;
    },

    onEventClick(event, e) {
      this.$router.push({ name: 'modifica-lavoro', params: { uuid: event.id } });
      e.stopPropagation();
    },

    onCellClick(date) {
      const dateStr = moment(date).format('YYYY-MM-DD');
      const timeStr = moment(date).format('HH:mm');
      
      this.$router.push({ 
        name: 'admin-create-work', 
        query: { date: dateStr, time: timeStr } 
      });
    },

    onEventDrop({ event }) {
      const dateStr = moment(event.start).format('YYYY-MM-DD');
      const timeStr = moment(event.start).format('HH:mm');
      const teamId = event.split;
      const uuid = event.id;

      let formData = new FormData();
      formData.append("data_programmazione", dateStr);
      formData.append("ora_programmazione", timeStr);
      if (teamId) {
        formData.append("team_id", teamId);
      }

      this.axios
        .put(`dockyard/${uuid}/programmazione`, formData)
        .then((response) => {
          if (response.data.success) {
            this.fetchAdminLavori();
            this.$swal.fire({
              icon: "success",
              title: "Programmazione Aggiornata",
              text: "L'intervento è stato riprogrammato con successo.",
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            });
          } else {
            throw new Error(response.data.error || "Errore sconosciuto");
          }
        })
        .catch((error) => {
          console.error("Errore aggiornamento programmazione:", error);
          this.$swal.fire({
            icon: "error",
            title: "Errore",
            text: "Impossibile aggiornare la programmazione dell'intervento.",
          });
          this.fetchAdminLavori();
        });
    }
  }
};
</script>

<style>
/* Modern styling for vue-cal wrapper */
.vuecal {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.05), 0 0 1px 1px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: #fff;
  font-family: var(--font-main, sans-serif);
}

/* Header styling */
.vuecal__header {
  border-bottom: 1px solid #f1f5f9;
}

.vuecal__title-bar {
  background-color: #ffffff;
  color: #0f172a;
  font-weight: 700;
  font-size: 1.15rem;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
}

/* Styled navigation arrows */
.vuecal__arrow {
  color: #64748b;
  font-size: 1.3rem;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}
.vuecal__arrow:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

/* Segmented control view-switching menu */
.vuecal__menu {
  background-color: #f8fafc;
  padding: 6px;
  display: flex;
  justify-content: center;
  gap: 4px;
}
.vuecal__menu button {
  border: none;
  background: transparent;
  padding: 8px 18px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #64748b;
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
}
.vuecal__menu button:hover {
  color: #0f172a;
  background-color: rgba(0, 0, 0, 0.03);
}
.vuecal__menu button.vuecal__view-btn--active {
  background-color: #ffffff !important;
  color: var(--primary) !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
}

/* Grid layout & line styling */
.vuecal__cell {
  border: 1px solid #f1f5f9;
  transition: background-color 0.15s ease;
}
.vuecal__cell:hover {
  background-color: rgba(248, 250, 252, 0.4);
}
.vuecal__time-column {
  border-right: 1px solid #f1f5f9;
  background-color: #f8fafc;
  color: #64748b;
  font-size: 0.8rem;
  font-weight: 500;
}
.vuecal__time-cell {
  border-bottom: 1px solid rgba(241, 245, 249, 0.5);
}

/* Highlight today/current cell */
.vuecal__cell--today, .vuecal__cell--current {
  background-color: rgba(37, 99, 235, 0.02) !important;
}
.vuecal__cell--today .vuecal__cell-date {
  background-color: var(--primary);
  color: #ffffff;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.25);
}

/* Split Days headers */
.vuecal__split-days-headers {
  background-color: #ffffff;
  border-bottom: 1px solid #f1f5f9;
}
.vuecal__split-days-headers .vuecal__cell {
  font-weight: 600;
  color: #475569;
  padding: 10px 0;
  font-size: 0.9rem;
}
.vuecal-split-team {
  border-right: 1px solid #f1f5f9;
}

/* Modern Soft SaaS Event styling */
.vuecal__event {
  cursor: pointer;
  border-radius: 8px !important;
  padding: 6px 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 3px 4px;
}
.vuecal__event:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
  z-index: 10;
}

/* Event typography */
.vuecal__event-title {
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: -0.1px;
  margin-bottom: 2px;
}
.vuecal__event-content {
  font-size: 0.72rem;
  opacity: 0.85;
  line-height: 1.3;
}

/* Event status themes */
.vuecal-event-default {
  background-color: rgba(100, 116, 139, 0.08) !important;
  color: #334155 !important;
  border: none !important;
  border-left: 4px solid #64748b !important;
}
.vuecal-event-primary {
  background-color: rgba(37, 99, 235, 0.07) !important;
  color: #E07B00 !important;
  border: none !important;
  border-left: 4px solid #E07B00 !important;
}
.vuecal-event-success {
  background-color: rgba(16, 185, 129, 0.07) !important;
  color: #047857 !important;
  border: none !important;
  border-left: 4px solid #10b981 !important;
}
.vuecal-event-warning {
  background-color: rgba(245, 158, 11, 0.07) !important;
  color: #b45309 !important;
  border: none !important;
  border-left: 4px solid #f59e0b !important;
}
.vuecal-event-danger {
  background-color: rgba(239, 68, 68, 0.07) !important;
  color: #b91c1c !important;
  border: none !important;
  border-left: 4px solid #ef4444 !important;
}

/* ── Tokens from style.md ── */
.cw-header-icon {
  width: 48px; height: 48px; border-radius: 14px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 12px rgba(247,147,30,0.35); flex-shrink: 0;
}
.cw-header-icon .mdi { color: #fff; font-size: 1.5rem; }

.cw-card {
  background: #fff; border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  padding: 28px; border: 1px solid rgba(0,0,0,0.05);
}

.cw-btn-submit {
  display: inline-flex; align-items: center;
  padding: 10px 24px; border: none; border-radius: 30px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.88rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 14px rgba(247,147,30,0.35);
  transition: all 0.2s;
}
.cw-btn-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #E07B00, #C96A00);
  box-shadow: 0 6px 18px rgba(247,147,30,0.45); transform: translateY(-1px);
  color: #fff; text-decoration: none;
}

/* Tabs da style.md per il toggle */
.cw-location-tabs {
  display: flex; background: #f1f5f9;
  border-radius: 12px; padding: 4px; gap: 4px;
}
.cw-loc-tab {
  display: flex; flex-direction: row;
  align-items: center; justify-content: center; gap: 6px;
  padding: 8px 16px; border: none; border-radius: 9px;
  background: transparent; color: #94a3b8;
  font-size: 0.75rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.04em;
  cursor: pointer; transition: all 0.2s;
  outline: none;
}
.cw-loc-tab .mdi { font-size: 1.15rem; }
.cw-loc-tab:hover { background: rgba(255,255,255,0.7); color: #F7931E; }
.cw-loc-tab.active {
  background: #fff; color: #E07B00;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
</style>
